// export const BASE_URL = 'http://192.168.1.163:4040/api_v0.2'
// export const BASE_URL = 'http://192.168.50.219:4040/api_v0.2'
// export const BASE_URL = 'https://api.fightingprohk.com/api_v0.1'
// export const BASE_URL = 'http://3.1.200.54:4040/api_v0.3'
export const BASE_URL = 'https://portal-api.shopper.com.hk/api_v0.4'
export const SCHEME = 'exp0a5482cb365840debaf009658692c5f2'